import React from "react";
import ApiHelper from "../lib/UniversalTable/CoreHelpers/ApiHelper";
import {
  formatRangeFilterDateForDisplay,
  getDateOutOfAllowedRangeMessage,
  hasDateOutOfAllowedRange,
  hasInvalidDateBounds,
  hasInvalidRangeOrder,
  normalizeRangeFilterDate
} from "../lib/UniversalTable/CoreHelpers/rangeFilterHelpers";

export default class SingleRangeFilterAbstract extends React.Component {
  state = {
    errors: {
      min: null,
      max: null
    }
  };

  normalizeRangeFieldValue(value) {
    if (value === "" || value === null) {
      return null;
    }

    return value;
  }

  handleChange(field, value) {
    const { value: currentValue, onChange } = this.props;

    let newValue = {
      min: null,
      max: null,
      ...(currentValue || {})
    };

    newValue[field] = this.normalizeRangeFieldValue(value);

    onChange(newValue);

    return newValue;
  }

  validateValues(providedValue) {
    let { value: currentValue, translate, onChange, column } = this.props;
    let { errors } = this.state;

    currentValue = {
      ...(currentValue || {}),
      ...(providedValue || {})
    };

    let newValue = {
      min: null,
      max: null,
      ...(currentValue || {})
    };

    for (let key in currentValue) {
      if (currentValue.hasOwnProperty(key)) {
        const normalizedValue = this.normalizeRangeFieldValue(currentValue[key]);

        if (normalizedValue === null) {
          errors[key] = null;
          newValue[key] = null;
        } else if (
          normalizedValue !== null &&
          ApiHelper.getIsDateRange(column)
        ) {
          const parsedDate = normalizeRangeFilterDate(normalizedValue);

          if (parsedDate === null) {
            errors[key] = null;
            newValue[key] = normalizedValue;
          } else {
            errors[key] = null;
            newValue[key] = parsedDate;
          }
        } else if (
          currentValue[key] !== null &&
          (!isNaN(currentValue[key]) ||
            !isNaN(String(currentValue[key]).replace(",", ".")))
        ) {
          errors[key] = null;
          newValue[key] = Number(String(currentValue[key]).replace(",", "."));
        } else if (isNaN(currentValue[key]) && currentValue[key] !== null) {
          errors[key] = translate("this_value_should_be_a_number");
        }
      }
    }

    onChange(newValue);

    this.setState({ errors });
  }

  getValue(field) {
    const {
      column,
      column: { filter_data },
      value
    } = this.props;

    const raw =
      value &&
      typeof value[field] !== "undefined" &&
      value[field] !== null &&
      value[field] !== ""
        ? value[field]
        : filter_data[field];

    if (
      !ApiHelper.getIsDateRange(column) ||
      raw === null ||
      raw === undefined ||
      raw === ""
    ) {
      return raw;
    }

    return formatRangeFilterDateForDisplay(raw) ?? raw;
  }

  getValueExists(field) {
    const { value } = this.props;

    return (
      value &&
      typeof value[field] !== undefined &&
      value[field] !== null &&
      value[field] !== ""
    );
  }

  getHasInvalidDateBounds() {
    const { column, value } = this.props;

    if (!ApiHelper.getIsDateRange(column) || !value) {
      return false;
    }

    return hasInvalidDateBounds(value);
  }

  getHasDateOutOfAllowedRange() {
    const { column, value } = this.props;

    if (!ApiHelper.getIsDateRange(column) || !value || this.getHasInvalidDateBounds()) {
      return false;
    }

    return hasDateOutOfAllowedRange(value, column);
  }

  getDateOutOfAllowedRangeMessage(translate) {
    const { column } = this.props;

    return getDateOutOfAllowedRangeMessage(column, translate);
  }

  getValueIsInvalid() {
    const { column, value } = this.props;

    if (
      !value ||
      this.getHasInvalidDateBounds() ||
      this.getHasDateOutOfAllowedRange()
    ) {
      return false;
    }

    return hasInvalidRangeOrder(
      value,
      column,
      ApiHelper.getIsDateRange(column)
    );
  }

  clearValue(field) {
    const valueAfterClearing = this.handleChange(field, null);
    this.validateValues(valueAfterClearing);
  }
}
